/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      
      // Code by Ruby - Convx - #2352 

      // this.debouncedOnSubmit = debounce((event) => {
      //   this.onSubmitHandler(event);
      // }, 200);
      // this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));

      this.previousValues = new Map(); // Here is to store the previous values

      this.inputs.forEach(select => {
        this.previousValues.set(select, select.value);
        select.addEventListener('change', (event) => this.onChangeHandler(event));
      });
      // End of #2352
    }
    
    // Code by Ruby - Convx - #2352 
    onChangeHandler(event) {
      const selectElement = event.target;
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const targetUrl = selectedOption.getAttribute('data-url');

      if (targetUrl) {
        // Prevent changing selection value and redirect to the target URL
        event.preventDefault();
        selectElement.value = this.previousValues.get(selectElement); // Revert to previous value
        window.location.href = targetUrl;
        return;
      }
      this.previousValues.set(selectElement, selectElement.value);
      this.onSubmitHandler(event);
    }
    // End of #2352

    onSubmitHandler(event) {
      if (this.form) {
        const input = this.form.elements["country_code"];

        if (input) {
          if (input.value === "CN") {
            this.form.insertAdjacentHTML("beforeend", `<input type="hidden" name="language_code" value="zh-CN">`);
          } else {
            this.form.insertAdjacentHTML("beforeend", `<input type="hidden" name="language_code" value="en">`);
          }
        }

        this.form.submit();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
